<div class="logs-signpost">
    <ng-template #signpostAlerts>
        <!-- Error Section -->
        <logs-errors
            [show]="logsSignpostStore.showErrorMessage$ | async"
            alertType="danger"
            class="logs-page-signpost__alert"
            errorMessage="{{ l10nKeys.defaultErrorMsgLabel | vtranslate }}"
        ></logs-errors>

        <!--  Timeout Message -->
        <logs-errors
            [show]="logsSignpostStore.showTimeoutMessage$ | async"
            alertType="warning"
            class="logs-page-signpost__alert"
            timeoutMessageLabel="{{ l10nKeys.timeoutMessageLabel | vtranslate }}"
        ></logs-errors>

        <!-- Empty Data Info Section -->
        <logs-errors
            [show]="logsSignpostStore.showEmptyDataMessage$ | async"
            alertType="info"
            size="default"
            infoMessageLabel="{{ l10nKeys.emptyDataMessageLabel | vtranslate }}"
        ></logs-errors>
    </ng-template>

    <!-- Custom Or Default Signpost Section-->
    <logs-signpost-custom
        *ngIf="isCustomComponent; else defaultSignpost"
        [poolId]="poolId"
    >
        <ng-container *ngTemplateOutlet="signpostAlerts"></ng-container>
    </logs-signpost-custom>
</div>

<ng-template #defaultSignpost>
    <logs-signpost-default
        [configKey]="logsSignpostStore.logSelectedSignpostConfigKey$ | async"
        [poolId]="poolId"
    >
        <ng-container *ngTemplateOutlet="signpostAlerts"></ng-container>
    </logs-signpost-default>
</ng-template>
